import { render, staticRenderFns } from "./AgencyChooseBeneficiariesEmpty.vue?vue&type=template&id=a4bf1e44&"
import script from "./AgencyChooseBeneficiariesEmpty.vue?vue&type=script&lang=js&"
export * from "./AgencyChooseBeneficiariesEmpty.vue?vue&type=script&lang=js&"
import style0 from "./AgencyChooseBeneficiariesEmpty.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VExpandTransition } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
installComponents(component, {VExpandTransition,VFlex,VLayout,VSelect})
